<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Reported Reviews
                        <span v-if="is_loading || fetching_data"
                              class="button is-white has-text-right preloader"
                              :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>

            <!-- <div class="columns" v-if="!is_loading"> -->
            <!--     <div class="column is-6-mobile is-8-desktop is-8-widescreen padding-left-0  padding-bottom-0"> -->
            <!--         <div v-resultsCount="dataSet.total"></div> -->
            <!--     </div> -->
            <!-- </div> -->

            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                        <tr>
                            <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Date&nbsp;reported</td>
                          <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business</td>
                            <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Review title</td>
                            <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Reporting reason</td>
                            <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Reported&nbsp;from</td>
                            <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Report status</td>
                          <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Reported By</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="10">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>
                        <tr class="margin-bottom-20" v-for="(report, index) in items"  v-if="items.length > 0"
                            @click="gotoReporterReviewDetails(report.businessSlug, report.permalink, report.reportSlug, report.id, report.review_id)"
                        >
                            <td class="is-narrow-mobile is-desktop break-all">{{report.created_at | prettyDate}}&nbsp{{report.created_at | prettyTime}}</td>
                          <td class="is-narrow-mobile is-desktop break-all">{{ asText(report.businessName, 80) }}</td>
                            <td class="is-narrow-mobile is-desktop break-all">{{ asText(report.review_title, 30) }}</td>
                            <td class="is-narrow-mobile is-desktop break-all"><span class="has-text-weight-bold">{{report.reasonCategory}}</span></td>
                            <td class="is-narrow-mobile is-desktop">
                                <span v-if="getReportedFrom(report) === 'BusinessPortal'">Business Portal</span>
                                <span v-else >App</span>
                            </td>
                            <td class="is-narrow-mobile is-desktop break-all">{{ displayReportedReviewStatus(report.status) }}</td>
                          <td class="is-narrow-mobile is-desktop break-all">{{ report.reporter_email }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <cursor-paginator :dataSet="dataSet" @changed="getReportedReviewsListings"></cursor-paginator>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions,valid-jsdoc, no-useless-escape */
  import MultipleSelectionDropDown from './../../components/MultipleSelectionDropDown'
  import Dropdown from './../../components/DropDown.vue'
  import axios from 'axios'
  import CursorPaginator from './../../components/CursorPaginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'
  import moment from 'moment'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Reported Reviews'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Reported Reviews'
      })
    },
    components: {CursorPaginator, MultipleSelectionDropDown, Dropdown},
    mixins: [misc],
    data () {
      return {
        no_of_items: 0,
        is_loading: true,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        returnURL: '',
        total_records: 0,
        search_message: undefined,
        allChecked: false,
        checked_items: []
      }
    },
    created () {
      if (this.$route.query.returnURL) {
        this.returnURL = this.$route.query.returnURL
      }
      this.getReportedReviewsListings(this.returnURL)
    },
    methods: {
      /**
       * Goes to reported reviews page for choosen busines
       * @param {string} businessSlug Business slug
       * @param {string} permalink Review Permalink
       * @param {string} reportSlug Report Slug
       * @param {string} reportId Report Id
       * @param {string} reviewId Review Id
       * @returns {void}
       */
      gotoReporterReviewDetails (businessSlug, permalink, reportSlug, reportId, reviewId) {
        let url = `/reported-review/${businessSlug}/${permalink}/${reportSlug}/${reportId}/${reviewId}`
        if (this.returnURL !== null && this.returnURL.length > 0) {
          url = `/reported-review/${businessSlug}/${permalink}/${reportSlug}/${reportId}/${reviewId}?returnURL=${encodeURI(this.page)}`
        }
        this.$router.push(url)
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getReportedReviewsListings(null)
      },
      /**
       * Method to display reported review status
       * @param {string}
       * @return {void}
       */
      displayReportedReviewStatus (reportStatus) {
        return reportStatus === 'REPORTED' ? 'Reported' : reportStatus === 'IN_PROGRESS' ? 'In-progress' : reportStatus === 'RE_OPENED' ? 'Re-opened' : 'Resolved'
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReportedReviewsListings (page) {
        this.page = page || null
        let endpoint = `/reported-reviews`
        if (page !== null && page !== '') {
          endpoint = page
        }
        this.fetching_data = true
        axios.get(endpoint.replace(/^http:\/\//i, 'https://'))
            .then((response) => {
              this.items = response.data.data
              // response.data.data = undefined
              this.dataSet = response.data
              this.is_loading = false
              this.fetching_data = false
              if (this.dataSet && typeof this.dataSet.prev_page_url !== 'undefined') {
                this.returnURL = this.dataSet.prev_page_url
              }
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        return `/reported-reviews/?page=${page}`
      },
      /**
       * @param {object} data reported review object
       * @returns {string}
       */
      getReportedFrom (data) {
        if (data !== null) {
          if (data.bizUserName !== null && data.bizUserName.length > 0) {
            return 'BusinessPortal'
          }
          return 'App'
        }
      },
      preventClick (event) {
        event.stopPropagation()
      }
    },
    filters: {
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      prettyTime (date) {
        return moment(date).format('HH:mm')
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    tr {
        cursor: pointer;
    }

    .table > thead > tr > td:first-child { min-width: 100px; }

    .break-all {
        word-break: break-all;
    }

    .table > thead > tr > td:first-child {
        min-width: 40px
    }
    .paddingless-td {
        padding: 0px !important;
    }
    .clickable-checkbox {
        display: inline-block;
        padding: 15px !important;
        cursor: pointer;
        -webkit-user-select: none; /* webkit (safari, chrome) browsers */
        -moz-user-select: none; /* mozilla browsers */
        -khtml-user-select: none; /* webkit (konqueror) browsers */
        -ms-user-select: none; /* IE10+ */
    }
</style>



// WEBPACK FOOTER //
// src/pages/reported-reviews/ReportedReviewsListing.vue